import React from "react";
import CompanyTimeline from "../../sections/AboutSection/About-timeline/about-timeline";
// import PaperBagGallery from "../../sections/HomeSection/Home-products-2/home-products-2";
import HomeProducts from "../../sections/HomeSection/Home-product-section/Home-products";
import TeamSection from "../../sections/AboutSection/our-team/our-team";
import ProductApplication from "../../sections/AboutSection/product -used-in/product-use-in";
// import HistorySection from "../../sections/AboutSection/our-history/our-history";
import AboutUs from "../../sections/AboutSection/aboout-klm/about-klm";// import StatsCounter from "../../sections/AboutSection/about-mapping-journey/about-mapping-journey";
// import ServiceSection from "../../sections/AboutSection/about-products2/about-products2";
// import ProductsSection from "../../sections/AboutSection/about-products2/about-products2";
import MissionVisionSection from "../../sections/AboutSection/vision-mission/vision-mission";
const About=()=>{
    return(
        <div>
            <AboutUs/>
        {/* <HistorySection/> */}
                <MissionVisionSection/>

        <CompanyTimeline/>
        {/* <ProductsSection/> */}
        {/* <PaperBagGallery/> */}
        <HomeProducts/>
        {/* <TeamSection/> */}
        {/* <StatsCounter/> */}
        <ProductApplication/>
        </div>
    )
}
export default About